(function(){
'use strict';
var obs=new IntersectionObserver(function(e){e.forEach(function(e){if(e.isIntersecting){e.target.classList.add('gs--visible');obs.unobserve(e.target)}})},{threshold:0.12,rootMargin:'0px 0px -40px 0px'});
document.querySelectorAll('[data-gs-reveal],.gs-stagger').forEach(function(el){obs.observe(el)});
document.querySelectorAll('[data-gs-faq]').forEach(function(item){
  var t=item.querySelector('.gs-faq__q');
  if(!t)return;
  t.addEventListener('click',function(){
    var o=item.classList.contains('gs--open');
    document.querySelectorAll('[data-gs-faq].gs--open').forEach(function(x){x.classList.remove('gs--open');x.querySelector('.gs-faq__q').setAttribute('aria-expanded','false')});
    if(!o){item.classList.add('gs--open');t.setAttribute('aria-expanded','true')}
  })
});
var car=document.querySelector('[data-gs-carousel]');
if(car){
  var tr=car.querySelector('[data-gs-track]'),cards=Array.from(tr.querySelectorAll('.gs-review')),dw=car.querySelector('[data-gs-dots]'),cur=0,atm;
  cards.forEach(function(_,i){var d=document.createElement('button');d.className='gs-reviews__dot'+(i===0?' gs--active':'');d.setAttribute('aria-label','Review '+(i+1));d.addEventListener('click',function(){go(i);rst()});dw.appendChild(d)});
  function go(idx){cur=Math.max(0,Math.min(idx,cards.length-1));var c=cards[cur];tr.scrollTo({left:c.offsetLeft-48,behavior:'smooth'});dw.querySelectorAll('.gs-reviews__dot').forEach(function(d,i){d.classList.toggle('gs--active',i===cur)})}
  function rst(){clearInterval(atm);atm=setInterval(function(){go((cur+1)%cards.length)},5000)}
  var pv=car.querySelector('[data-gs-prev]'),nx=car.querySelector('[data-gs-next]');
  if(pv)pv.addEventListener('click',function(){go(cur-1);rst()});
  if(nx)nx.addEventListener('click',function(){go(cur+1);rst()});
  rst()
}
document.querySelectorAll('[data-gs-atc]').forEach(function(form){
  form.addEventListener('submit',async function(e){
    e.preventDefault();
    var btn=form.querySelector('.gs-card__atc'),lbl=btn?btn.querySelector('.gs-card__atc-label'):null,orig=lbl?lbl.textContent:(btn?btn.textContent:'');
    if(!btn||btn.disabled)return;
    btn.disabled=true;if(lbl)lbl.textContent='Adding…';
    try{var r=await fetch('/cart/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
    if(r.ok){if(lbl)lbl.textContent='Added ✓';document.dispatchEvent(new CustomEvent('cart:updated'));setTimeout(function(){if(lbl)lbl.textContent=orig;btn.disabled=false},2200)}
    else throw new Error()}catch(_){if(lbl)lbl.textContent=orig;btn.disabled=false}
  })
});
document.querySelectorAll('a[href^="#"]').forEach(function(a){
  a.addEventListener('click',function(e){
    var t=document.querySelector(this.getAttribute('href'));
    if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth',block:'start'})}
  })
})
})();